var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComposite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 42",
    enableBackground: "new 0 0 33 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M7 0l25 14 1 28-26-5zM0 0h4.1v36.3H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComposite);
export default __webpack_public_path__ + "static/media/composite.4869ad35a7c886c9396d29aead085d9b.svg";
export { ForwardRef as ReactComponent };